import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "tagtextexportcharacterset"
    }}>{`TagTextExportCharacterSet`}</h1>
    <p>{`Character set options exporting tagged text files.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ASCII`}</strong>{` = 1095975753`}</p>
      <p parentName="blockquote">{`ASCII.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ANSI`}</strong>{` = 1095652169`}</p>
      <p parentName="blockquote">{`ANSI.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`UNICODE`}</strong>{` = 1249209961`}</p>
      <p parentName="blockquote">{`Unicode.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SHIFT_JIS`}</strong>{` = 1249077875`}</p>
      <p parentName="blockquote">{`Shift_JIS.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GB18030`}</strong>{` = 1416061491`}</p>
      <p parentName="blockquote">{`Uses GB18030 encoding.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KSC5601`}</strong>{` = 1414230883`}</p>
      <p parentName="blockquote">{`Uses KSC5601 encoding.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CHINESE_BIG_5`}</strong>{` = 1415799349`}</p>
      <p parentName="blockquote">{`Chinese Big 5`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CENTRALEUROPEAN_ISO`}</strong>{` = 1416184645`}</p>
      <p parentName="blockquote">{`The Central European (ISO) character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CYRILLIC_ISO`}</strong>{` = 1416184697`}</p>
      <p parentName="blockquote">{`The Cyrillic (ISO) character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GREEK_ISO`}</strong>{` = 1416185707`}</p>
      <p parentName="blockquote">{`The Greek (ISO) character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`WINDOWS_ARABIC`}</strong>{` = 1417101682`}</p>
      <p parentName="blockquote">{`The Windows Arabic character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`WINDOWS_HEBREW`}</strong>{` = 1417103458`}</p>
      <p parentName="blockquote">{`The Windows Hebrew character set.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      